import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { uiActions } from "../store/ui/ui-slice";
import { dispatch } from "../store";

const GetLocalStorage = ({ children }) => {
  const { token } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(uiActions.setLoading(false));
    dispatch(uiActions.setFormSubmitLoading(false));
  }, [dispatch]);

  if (!token) {
    return children;
  }

  return <Navigate to="/dashboard" replace />;
};

export default GetLocalStorage;
